"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9824],{

/***/ 19824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94449);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59806);
/* harmony import */ var src_hooks_useSystem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72337);
/* harmony import */ var _react_oauth_google__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82863);
/* harmony import */ var client_contexts_Login_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27422);







var GoogleOneTapLogin = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_2__/* .useMarket */ .A)(), market = ref.market, language = ref.language;
    var apiHostName = (0,src_hooks_useSystem__WEBPACK_IMPORTED_MODULE_3__/* .useSystem */ .u)().apiHostName;
    (0,_react_oauth_google__WEBPACK_IMPORTED_MODULE_4__/* .useGoogleOneTapLogin */ ._7)({
        use_fedcm_for_prompt: true,
        onSuccess: function(data) {
            if (!data) {
                return;
            }
            dispatch((0,client_contexts_Login_actions__WEBPACK_IMPORTED_MODULE_5__/* .loginGoogleRequestAction */ .v9)({
                hostname: apiHostName,
                data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    token: data.credential
                }, data),
                market: market,
                language: language
            }));
        }
    });
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(GoogleOneTapLogin));


/***/ })

}]);